(function () {
  'use strict';

  angular
    .module('commons')
    .directive('ngFile', ngFile);

  function ngFile($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var onChange = $parse(attrs.ngFile);
        element.on('change', function (event) {
          onChange(scope, {$files:event.target.files});
          element.val(null);  // clear input
        })
      }
    };
  }

}());
